import { UpcomingCustomInterview } from '../api/roundsApi';
import {
  CustomInterviewListItem,
  JDExtractedData,
  SavedResumeFromDB,
} from '../api/interviewBuilderApi';

export function minimalInterviewFromSavedResume(resume: SavedResumeFromDB): UpcomingCustomInterview {
  return {
    id: resume.interviewId,
    name: resume.interviewName,
    deadline: resume.createdAt,
    jobDescription: '',
    status: 'published',
    ownerType: 'user',
    rounds: [],
    jdProcessingStatus: 'processed',
    jdExtractedData:
      resume.skills?.length || resume.roleName
        ? {
            role_name: resume.roleName,
            skills: resume.skills ?? [],
            responsibilities: [],
            qualifications: [],
            additional_info: {},
          }
        : null,
    accepted: true,
    round_session: null,
  };
}

export function mapCustomInterviewToUpcoming(
  item: CustomInterviewListItem,
  fallbackName: string,
): UpcomingCustomInterview {
  const jd = item.jdExtractedData;
  return {
    id: item.id,
    name: item.name || fallbackName,
    deadline: item.updatedAt || item.createdAt,
    jobDescription: item.jobDescription || '',
    status: item.status,
    ownerType: item.ownerType,
    rounds: [],
    jdProcessingStatus: item.jdProcessingStatus,
    jdExtractedData: jd
      ? {
          role_name: jd.role_name,
          company_name: jd.company_name,
          domain_name: jd.domain_name,
          skills: jd.skills,
          responsibilities: jd.responsibilities,
          qualifications: jd.qualifications,
          additional_info: jd.additional_info ?? {},
          confidence_score: jd.confidence_score,
        }
      : null,
    accepted: true,
    round_session: null,
  };
}

export function buildUpcomingFromPipeline(params: {
  interviewId: string;
  name: string;
  jobDescription: string;
  deadline?: string;
  extractedData: JDExtractedData | null;
  jdProcessingStatus?: string | null;
  status?: string;
  ownerType?: string;
}): UpcomingCustomInterview {
  const jd = params.extractedData;
  return {
    id: params.interviewId,
    name: params.name,
    deadline: params.deadline || new Date().toISOString(),
    jobDescription: params.jobDescription,
    status: params.status ?? 'draft',
    ownerType: params.ownerType ?? 'user',
    rounds: [],
    jdProcessingStatus: params.jdProcessingStatus ?? (jd ? 'processed' : null),
    jdExtractedData: jd
      ? {
          role_name: jd.role_name,
          company_name: jd.company_name,
          domain_name: jd.domain_name,
          skills: jd.skills,
          responsibilities: jd.responsibilities,
          qualifications: jd.qualifications,
          additional_info: jd.additional_info ?? {},
          confidence_score: jd.confidence_score,
        }
      : null,
    accepted: false,
    round_session: null,
  };
}
